'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './link-button.component';
import dynamic from 'next/dynamic';

const DynamicLinkButtonComponent: ComponentType<Props> = dynamic(
  () => import('./link-button.component')
);

export default DynamicLinkButtonComponent;

export function calculateLinkButtonPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [{ sinceWidth: 0, height: 60 }];

  return {
    heightSinceWidth
  };
}
